import React from 'react';
import UserSVG from '../../../admin-dashboard-tables/assets/UserSVG';

interface Props {
  title?: string,
}

const UserFilterDisplay: React.FC<Props> = ({
  title,
}) => {
  return (
    <span className="d-flex align-items-center mr-1">
      <span
        className="d-flex align-items-center mr-2"
        style={{
          width: '10px',
          height: '10px',
        }}
      >
        <UserSVG />
      </span>
      <span>{title}</span>
    </span>
  );
};

UserFilterDisplay.defaultProps = {
  title: 'User:',
};

export default UserFilterDisplay;
